module.exports = __webpack_public_path__ + "static/media/intro-screen-circle-icon.b9c6e36c.png";